import React from 'react';
import _ from "underscore";

const MobiControl  = function(props){
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id} />);
    
    if (childBlocks.length > 0) {
        return (
            <category name='MobiControl' id='mobicontrol' iconclass='category with-icon-paths snap-icon-SOTI_Mobicontrol'>
                <label text={"MobiControl"}/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default MobiControl